import type { JsonValue } from "@/types/adminV2";

export const parseJsonInput = (args: {
  raw: string;
  label: string;
  allowEmpty: boolean;
}): {
  value: JsonValue | null;
  error: string | null;
} => {
  const trimmed = args.raw.trim();
  if (trimmed.length === 0) {
    if (args.allowEmpty) {
      return {
        value: null,
        error: null,
      };
    }

    return {
      value: null,
      error: `${args.label} is required.`,
    };
  }

  try {
    return {
      value: JSON.parse(trimmed) as JsonValue,
      error: null,
    };
  } catch {
    return {
      value: null,
      error: `${args.label} must be valid JSON.`,
    };
  }
};

export const prettyJson = (value: unknown): string => {
  return JSON.stringify(value, null, 2);
};
